@if (showAllPopup) {
  <div class="custom-popup task-group-popup explosure-segs-detail modal left fade">
    <div class="modal-dialog" (clickOutside)="hideAllPopupFn($event);">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title card-title d-flex justify-content-between w-100">
            <span>{{ 'Exposure By SEGs' | translate }}</span>
            <img (click)="hideAllPopupFn($event);" class="close-popup" src="assets/images/close.png">
          </h4>
        </div>
        <div class="modal-body">
          <div class="card-inner-main-div">
            <div class="tableColStyle">
              <div class="table-responsive" matSortDisableClear matSort matSortActive="severity" matSortDirection="asc" (matSortChange)="sortAllSEG($event)">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" width="10px">
                        <a></a>
                      </th>
                      <th class="shorting-arrow" scope="col" mat-sort-header="segName" style="width: 31%">
                        <a>{{ 'SEG' | translate }}</a>
                      </th>
                      <th class="shorting-arrow" scope="col" mat-sort-header="severity"
                        style="width: 24%">
                        <a class="sort-icon">{{ 'Severity' | translate }}</a>
                      </th>
                      <th class="shorting-arrow" scope="col" mat-sort-header="workers"
                        style="width: 16%">
                        <a class="sort-icon">{{ 'Employees' | translate }}</a>
                      </th>
                      <th class="td-width text-align-right" scope="col" mat-sort-header="change"
                        style="width: 17%">
                        <a class="sort-icon">{{ 'Change' | translate }}</a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (seg of exposureBySEGsAll; track trackByIndex($index)) {
                      <tr>
                        <td class="img-td seg-users">
                          <svg class="first-user" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1"
                            x="0px" y="0px" viewBox="0 0 15.4 24"
                            style="enable-background:new 0 0 15.4 24;" xml:space="preserve">
                            <path class="st0" style="fill:none;stroke-width:5;" [style]="'stroke:'+colors.white"
                              d="M31,19v9" />
                              <path class="st1"
                                [style]="{fill:seg?.previousColor?'#'+seg?.previousColor:colors.greyLight}"
                                d="M0,17.7c0-3,2.4-5.4,5.4-5.4H10c3,0,5.4,2.4,5.4,5.4V24H0V17.7z" />
                                <ellipse class="st2"
                                  [style]="{fill:seg?.previousColor?'#'+seg?.previousColor:colors.greyLight}"
                                  cx="7.6" cy="5.1" rx="5.1" ry="5.1" />
                                  <path class="st0" style="fill:none;stroke-width:5;" [style]="'stroke:'+colors.white"
                                    d="M8,19v9" />
                                  </svg>
                                  <img alt="" src="assets/images/center-arrow.svg" class="center-arrow">
                                  <svg class="second-user" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1"
                                    x="0px" y="0px" viewBox="0 0 15.4 24"
                                    style="enable-background:new 0 0 15.4 24;" xml:space="preserve">
                                    <path class="st0" style="fill:none;stroke-width:5;" [style]="'stroke:'+colors.white"
                                      d="M31,19v9" />
                                      <path class="st1" [style]="{fill:seg?.color?'#'+seg?.color:colors.greyLight}"
                                        d="M0,17.7c0-3,2.4-5.4,5.4-5.4H10c3,0,5.4,2.4,5.4,5.4V24H0V17.7z" />
                                        <ellipse class="st2"
                                          [style]="{fill:seg?.color?'#'+seg?.color:colors.greyLight}" cx="7.6"
                                          cy="5.1" rx="5.1" ry="5.1" />
                                          <path class="st0" style="fill:none;stroke-width:5;" [style]="'stroke:'+colors.white"
                                            d="M8,19v9" />
                                          </svg>
                                        </td>
                                        <td class="seg-name" title="{{seg.segName}}"><span
                                          class="font-light font-700 cursor-pointer"
                                          (click)="showSEGDetailFn(seg)"> {{ seg.segName
                                        }}</span></td>
                                        <td class="green-text"
                                          [style]="{color:(seg?.color?'#'+seg?.color:colors.greyLight)+' !important'}">
                                          <span [ngClass]="{'yellow-arrow-notification': seg.isGsdAlert}">{{
                                          (seg?.severity ? seg.severity : 0) | number : '1.0-2'}}</span>
                                        </td>
                                        <td>{{ seg?.workers ? seg.workers : 0 }}</td>
                                        <td class="text-align-right"><b>{{ (seg?.change ? seg.change : 0) | number :
                                        '1.0-2' }}%</b>
                                        @if (seg?.change && seg?.change > 0) {
                                          <span class="table-up-arrow"
                                            [ngClass]="{'arrow-notification': showChangeAlert(seg)}"
                                            >
                                            <img src="assets/images/black-up-arrow.svg">
                                          </span>
                                        }
                                        @if (!seg?.change || seg?.change < 0) {
                                          <span class="table-down-arrow">
                                            <img src="assets/images/black-down-arrow.svg">
                                          </span>
                                        }
                                      </td>
                                    </tr>
                                  }
                                  @if (exposureBySEGsAll && !exposureBySEGsAll.length) {
                                    <tr>
                                      <td colspan="5" class="no-data-available">{{errorMessage}}</td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
